
import { createPinia } from 'pinia'
 
const pinia = createPinia()
 
export default pinia


// WEBPACK FOOTER //
// ./src/pinia/pinia.js